
export const splitPragraph = (paragraph:string, splitter:string = '<br />') => {
  const splitedParagraph = paragraph.split(splitter);
  return splitedParagraph;
}